var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},_vm._l((_vm.navigation),function(item,index){return _c('div',{key:index,class:[
            { 'tab--active': _vm.isActive(item) },
            ("tab tab--" + (item.class))
        ],style:({ color: item.color }),on:{"click":function($event){return _vm.toggleTab(item)}}},[_c('i',{class:("icon-" + (item.icon))}),_c('span',[_vm._v(_vm._s(_vm.$t(item.text)))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }